module.exports = __webpack_public_path__ + "/assets/images/state-airline.317506d.svg";